import React from "react";

function Footer() {
  return (
    <div className="footer">
      <footer className="blockquote-footer bg-success text-light p-2 text-center">
        Grup 10 Healty{" "}
        <cite title="Source Title">@Yayasan Anak Bangsa Bisa</cite>
      </footer>
    </div>
  );
}

export default Footer;
